export const investigation_columns = [
    {
        dataField: 'key',
        text: 'Ключ',
        hidden: true
    },
    {
        dataField: 'dt',
        text: 'Дата',
        sort: true,
    },
    {
        dataField: 'user_name',
        text: 'Пользователь',
        sort: true,
    },
    {
        dataField: 'user_domain',
        text: 'Домен',
        sort: true,
    },
    {
        dataField: 'root_disk_serial',
        text: 'Диск',
        sort: true,
    },
    {
        dataField: 'ipv4_address',
        text: 'IP',
        sort: true,
    },
    {
        dataField: 'department_id',
        text: 'Код департамента'
    },
];
